module.exports = __webpack_public_path__ + "img/verifica_ts.1ad32f65.png";